import * as React from 'react';
import { Box, Heading } from "../..";

var GroupHeading = function GroupHeading(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "grey.100",
    px: 4,
    py: 2
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "regular",
    color: "grey.600"
  }, label));
};

export var Group = function Group(_ref2) {
  var children = _ref2.children,
      label = _ref2.label;
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(GroupHeading, {
    label: label
  }), children);
};